import DatasetAPI from '@apis/DatasetAPI';
import { useQuery } from '@tanstack/react-query';

export const useDescribeDatasets = () => {
  return useQuery({
    queryKey: ['describeDatasets'],
    queryFn: () => DatasetAPI.describeDatasets(),
  });
};
